import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import MessageThread from "@/components/MessageThread";

export default function ClientMessagesPage() {
    const { user } = useAuth();
    const [home, setHome] = useState(null);
    useEffect(() => {
        api.get("/me/client-home").then(({ data }) => setHome(data));
    }, []);

    if (!home || !user?.client_id) return <div className="p-8 text-[var(--text-muted)]">Loading…</div>;

    return (
        <div className="p-8 space-y-6 h-full" data-testid="client-messages-page">
            <div>
                <p className="label-tiny mb-2">/ Coach inbox</p>
                <h1 className="font-serif text-6xl">Messages</h1>
                <p className="text-sm text-[var(--text-muted)] mt-2">Talk to {home.coach_name} directly.</p>
            </div>
            <div className="h-[calc(100vh-260px)]">
                <MessageThread
                    mode="client"
                    clientId={user.client_id}
                    api={api}
                    otherName={home.coach_name}
                />
            </div>
        </div>
    );
}
